import { atom } from "jotai";

// 系统消息个数
export const SystemMsgCountAtom = atom(0);

// 通知消息个数
export const NoticeCountAtom = atom(0);

// 通知+系统消息个数
export const AllCountAtom = atom(
    get => get(SystemMsgCountAtom) + get(NoticeCountAtom)
);
